import { createSlice } from '@reduxjs/toolkit';
import { addNewFuel, editFuel, getAllFuels } from './fuelsService';

const initialState = {
  allFuels: {
    isFuelsLoading: null,
    isFuelsSuccess: null,
    fuelsMessage: null,
    pageCount: 0,
    fuels: [],
  },
  newFuel: {
    isFuelCreating: null,
    isFuelCreated: null,
    fuelCreationMsg: null,
  },

  editedFuel: {
    isEditingFuel: null,
    isFuelEdited: null,
    fuelEditedMsg: null
  }
};

const fuelsSlice = createSlice({
  name: 'fuel',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // PENDING
    builder
      .addCase(getAllFuels.pending, (state) => {
        state.allFuels = {
          ...initialState.allFuels, // Reset to initial state
          isFuelsLoading: true,
          fuelsMessage: 'Loading',
        };
      })

      // REJECTED
      .addCase(getAllFuels.rejected, (state, action) => {
        state.allFuels = {
          ...initialState.allFuels,
          isFuelsLoading: false,
          isFuelsSuccess: false,
          fuelsMessage: action.payload || 'Error occurred while fetching fuels',
        };
      })

      // FULFILLED
      .addCase(getAllFuels.fulfilled, (state, action) => {
        state.allFuels = {
          ...initialState.allFuels,
          isFuelsLoading: false,
          isFuelsSuccess: true,
          pageCount: action.payload.pageCount || 0,
          fuels: action.payload.data || [],
        };
      });

    //Fuel creating
    builder
      .addCase(addNewFuel.pending, (state) => {
        state.newFuel = {
          ...initialState.newFuel, // Reset to initial state
          isFuelCreating: true,
          fuelCreationMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(addNewFuel.rejected, (state, action) => {
        state.newFuel = {
          ...initialState.newFuel,
          isFuelCreating: false,
          isFuelCreated: false,
          fuelCreationMsg: action.payload || 'Error occurred while creating the fuel.',
        };
      })

      // FULFILLED
      .addCase(addNewFuel.fulfilled, (state, action) => {
        state.newFuel = {
          ...initialState.newFuel,
          isFuelCreating: false,
          isFuelCreated: true,
          fuelCreationMsg: action.payload || 'Successfully created the fuel.',
        };
      });

    //Fuel editing
    builder
      .addCase(editFuel.pending, (state) => {
        state.editedFuel = {
          ...initialState.editedFuel, // Reset to initial state
          isEditingFuel: true,
          fuelEditedMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(editFuel.rejected, (state, action) => {
        state.editedFuel = {
          ...initialState.editedFuel, // Reset to initial state
          isEditingFuel: false,
          isFuelEdited: false,
          fuelEditedMsg: action.payload || 'Error occurred while editing the fuel.',
        };
      })

      // FULFILLED
      .addCase(editFuel.fulfilled, (state, action) => {
        state.editedFuel = {
          ...initialState.editedFuel, // Reset to initial state
          isEditingFuel: false,
          isFuelEdited: true,
          fuelEditedMsg: action.payload || 'Successfully edited the fuel.',
        };
      });
  },
});

export default fuelsSlice.reducer;
